import { useState, FormEvent } from "react";

export default function HeroSection() {
  const [formData, setFormData] = useState({
    nome: "",
    whatsapp: "",
    idade: "",
    cidade: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const formatWhatsApp = (value: string) => {
    const digits = value.replace(/\D/g, "").slice(0, 11);
    if (digits.length === 0) return "";
    if (digits.length <= 2) return `(${digits}`;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    if (digits.length <= 11) return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "nome" || name === "cidade") {
      const onlyText = value.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
      setFormData({ ...formData, [name]: onlyText });
      return;
    }

    if (name === "whatsapp") {
      setFormData({ ...formData, whatsapp: formatWhatsApp(value) });
      return;
    }

    if (name === "idade") {
      const onlyNumbers = value.replace(/\D/g, "").slice(0, 2);
      setFormData({ ...formData, idade: onlyNumbers });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!formData.nome || !formData.whatsapp || !formData.idade || !formData.cidade) {
      setError("Por favor, preencha todos os campos.");
      return;
    }
    const whatsDigits = formData.whatsapp.replace(/\D/g, "");
    if (whatsDigits.length < 10) {
      setError("WhatsApp inválido. Use o formato (XX) XXXXX-XXXX.");
      return;
    }
    const idadeNum = parseInt(formData.idade, 10);
    if (isNaN(idadeNum) || idadeNum < 3 || idadeNum > 35) {
      setError("Idade deve ser entre 3 e 35 anos.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const body = new URLSearchParams();
      Object.entries(formData).forEach(([k, v]) => body.append(k, v));
      await fetch("https://readdy.ai/api/form/d75eeg341deorl02fat0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      window.location.href = "https://confirmar.fourmodelsseletivas.com.br/";
    } catch {
      setError("Erro ao enviar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Fashion Background"
          className="w-full h-full object-cover object-top"
          src="https://public.readdy.ai/ai/img_res/5233cb1ed4f3a8734f8613442c870aa5.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/85" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-0 lg:min-h-screen lg:flex lg:items-center">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center w-full">
          {/* Left */}
          <div className="text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-6">
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-4 py-1.5 rounded-full text-xs font-bold tracking-wider whitespace-nowrap flex items-center gap-1.5">
                <i className="ri-calendar-event-fill text-sm" />
                08/04 • 19:30
              </span>
              <span className="bg-white/10 backdrop-blur-sm text-white border border-white/20 px-4 py-1.5 rounded-full text-xs font-bold tracking-wider whitespace-nowrap flex items-center gap-1.5">
                <i className="ri-map-pin-fill text-yellow-500 text-sm" />
                CAXIAS DO SUL - RS
              </span>
              <span className="bg-red-600 text-white px-4 py-1.5 rounded-full text-xs font-bold tracking-wider whitespace-nowrap animate-pulse flex items-center gap-1.5">
                <i className="ri-fire-fill text-sm" />
                VAGAS LIMITADAS
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-white mb-4 leading-tight">
              Sua Carreira na Moda, TV e{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
                Redes Sociais Começa Aqui
              </span>
            </h1>

            <p className="text-base sm:text-lg text-gray-200 mb-2 font-light max-w-xl mx-auto lg:mx-0">
              Seletiva Oficial <strong className="text-white">Four Models</strong> em{" "}
              <strong className="text-yellow-500">Caxias do Sul - RS</strong>
            </p>
            <p className="text-lg sm:text-xl text-white mb-8 font-semibold max-w-xl mx-auto lg:mx-0 leading-relaxed">
              Descubra se você ou seu filho(a) tem perfil para moda, TV e internet.
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 sm:gap-8 text-white">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-black text-yellow-500">03–35</div>
                <div className="text-xs text-gray-300 mt-0.5">Anos</div>
              </div>
              <div className="w-px h-10 bg-gray-600 hidden sm:block" />
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-black text-yellow-500">100%</div>
                <div className="text-xs text-gray-300 mt-0.5">Gratuito</div>
              </div>
              <div className="w-px h-10 bg-gray-600 hidden sm:block" />
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-black text-yellow-500">0</div>
                <div className="text-xs text-gray-300 mt-0.5">Experiência necessária</div>
              </div>
            </div>

            <p className="text-yellow-400/70 text-xs mt-6 lg:hidden">
              ↓ Preencha o formulário abaixo e garanta sua vaga
            </p>
          </div>

          {/* Right - Form */}
          <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 sm:p-7">
              <div className="text-center mb-5">
                <p className="text-yellow-500 text-xs font-bold tracking-widest uppercase mb-1">
                  Inscrição Gratuita
                </p>
                <h2 className="text-xl sm:text-2xl font-black text-white leading-tight">
                  Garanta sua <span className="text-yellow-500">vaga gratuita</span>
                </h2>
                <p className="text-gray-300 text-xs mt-1">Leva menos de 30 segundos.</p>
              </div>

              <form
                  id="form-hero"
                  data-readdy-form="true"
                  className="space-y-3"
                  onSubmit={handleSubmit}
                >
                  <input
                    type="text"
                    className="w-full px-3 py-3 border-2 rounded-xl focus:outline-none transition-colors text-sm text-gray-900 bg-white/95 placeholder-gray-400 border-white/30 focus:border-yellow-500"
                    placeholder="Nome Completo *"
                    autoComplete="name"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                  />
                  <input
                    type="tel"
                    inputMode="numeric"
                    className="w-full px-3 py-3 border-2 rounded-xl focus:outline-none transition-colors text-sm text-gray-900 bg-white/95 placeholder-gray-400 border-white/30 focus:border-yellow-500"
                    placeholder="WhatsApp (XX) XXXXX-XXXX *"
                    autoComplete="tel"
                    name="whatsapp"
                    value={formData.whatsapp}
                    onChange={handleChange}
                    maxLength={16}
                  />
                  <input
                    type="text"
                    inputMode="numeric"
                    className="w-full px-3 py-3 border-2 rounded-xl focus:outline-none transition-colors text-sm text-gray-900 bg-white/95 placeholder-gray-400 border-white/30 focus:border-yellow-500"
                    placeholder="Idade (3 a 35 anos) *"
                    autoComplete="off"
                    maxLength={2}
                    name="idade"
                    value={formData.idade}
                    onChange={handleChange}
                  />
                  <input
                    type="text"
                    className="w-full px-3 py-3 border-2 rounded-xl focus:outline-none transition-colors text-sm text-gray-900 bg-white/95 placeholder-gray-400 border-white/30 focus:border-yellow-500"
                    placeholder="Sua Cidade *"
                    autoComplete="address-level2"
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleChange}
                  />
                  {error && (
                    <p className="text-red-400 text-xs text-center">{error}</p>
                  )}
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full mt-1 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black py-4 rounded-xl text-sm font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap shadow-lg shadow-yellow-500/30"
                  >
                    {loading ? "ENVIANDO..." : "GARANTIR MINHA VAGA GRATUITA"}
                  </button>
                </form>

              <p className="text-center text-gray-400 text-xs mt-3">
                <i className="ri-lock-fill text-yellow-500 mr-1" />
                Inscrição gratuita • Seus dados estão seguros
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 animate-bounce hidden lg:block">
        <i className="ri-arrow-down-line text-2xl text-yellow-500/60" />
      </div>
    </section>
  );
}
